import { useEffect, useMemo, useState } from "react";
import { Background, Button, ButtonContainer, Checked, Container, CustomInput, Headline, InfoLi, Input, InputContainer, Label, PackageContainer, Price, ProductCard, ProductInfo, Subtitle, TopContainerCard, TotalBottom, TotalCall, TotalPrice, TotalText, TotalTop, UnorderedList, ProductCardContainer, PackageInfo, InfoBtn, ContactMeContainer, ContactMeHeadline, ContactMeContent, Close, CloseButton, CloseIcon, ContactMeSubtitle, ModalInput, ModalInputContainer, ErrorMessage, ProductName, TotalRow } from "./ProductCardModule.style";
import { BloomreachLeadModel } from "../../types/BloomreachLeadModal";
import { postBloomreachLead } from "../../utils/api";
import { Product } from "../FormEnrollmentNew/components/Reciept/Reciept.style";
import Analytics from "../../utils/analytics";
import { TrackingFlowTypeEnum } from "../../types/TrackingFlowTypeEnum";

export interface ProductFeature {
  FeatureDescription: string;
  FeatureTitle: string;
  Key: string;
}

export interface ProductConfig {
  ProductTitle: string;
  Price: string;
  ProductBannerText: string;
  Features: ProductFeature[];
  ProductTargetVariant: string;
  Key: string;
  ProductId: string;
  DefaultChoosen: boolean;
}

export default function ProductCardModule() {
    const [productList, setProductList] = useState<ProductConfig[]>([]);
    const [unemploymentBenefitsChecked, setUnemploymentBenefitsChecked] = useState<boolean>(false);
    const [unionChecked, setUnionChecked] = useState<boolean>(false);
    const [salaryInsuranceChecked, setSalaryInsuranceChecked] = useState<boolean>(false);
    const [salaryInsuranceUnionChecked, setSalaryInsuranceUnionChecked] = useState<boolean>(false);
    const [hrJuraChecked, setHrJuraChecked] = useState<boolean>(false);
    const [basisChecked, setBasisChecked] = useState<boolean>(false);
    const [isPackage, setIsPackage] = useState<boolean>(false);
    const [isSelfemployeedPackage, setIsSelfemployeedPackage] = useState<boolean>(false);
    const [strikeThrough, setStrikeThrough] = useState<boolean>(false);
    const [headline, setHeadline] = useState<string>();
    const [subtitle, setSubtitle] = useState<string>();
    const [callText, setCallText] = useState<string>();
    const [packagePrice, setPackagePrice] = useState<number>();
    const [btnUrl, setBtnUrl] = useState<string>();
    const [btnText, setBtnText] = useState<string>();
    const [packageText, setPackageText] = useState<string>();
    const [campaignSource, setCampaignSource] = useState<string>();
    const [customer, setCustomer] = useState<string>();
    const [discountToken, setDiscountToken] = useState<string>();
    const [showContactMe, setShowContactMe] = useState<boolean>(false);
    const [firstName, setFirstName] = useState<string>();
    const [mobile, setMobile] = useState<string>();
    const [showMobileError, setShowMobileError] = useState<boolean>(false);
    const [showFirstNameError, setShowFirstNameError] = useState<boolean>(false);
   /*  const [email, setEmail] = useState<string>("");
    const [showEmailError, setShowEmailError] = useState<boolean>(false);
    const [consentChecked, setConsentChecked] = useState<boolean>(false);
    const [showConsentError, setShowConsentError] = useState<boolean>(false); */
    const [chosenProducts, setChosenProducts] = useState<string>();
    const [dataAtrr, setDataAttr] = useState<string>("product-card-selfemployed");
    const [openFeatureProductId, setOpenFeatureProductId] = useState<string | null>(null);
    const [choosenStep2, setDefaultStep2] = useState<boolean>(false);
    
    //Get data from umbraco backend
    useEffect(() => {
        const form = document.querySelector(`[data-component='product-card-module']`) as HTMLElement;
        const headline = form?.dataset.productcardsHeadline;
        const subtitle = form?.dataset.productcardsSubtitle;
        const products = form?.dataset.productcardsProductlist;
        const callText = form?.dataset.productcardsCallText;
        const btnUrl = form?.dataset.productcardsBtnUrl;
        const btnText = form?.dataset.productcardsBtnText;
        const packageText = form?.dataset.productcardsPackageText;
        const campaignSource = form?.dataset.productcardsCampaign;
        const customerType = form?.dataset.productcardsCustomerType;
        const discountToken = form?.dataset.productcardsDiscountToken;
        const defaultStep2 = form?.dataset.productcardsDefaultStep2;
        setHeadline(headline)
        setSubtitle(subtitle)
        setCallText(callText)
        setBtnUrl(btnUrl)
        setBtnText(btnText)
        setPackageText(packageText)
        setCampaignSource(campaignSource)
        setCustomer(customerType)
        setDiscountToken(discountToken)
        setDefaultStep2(defaultStep2 === "True" ? true : false)
        if(products) {
            setProductList(JSON.parse(products) as ProductConfig[]);
        }
    }, [])

   const customerTranslation = useMemo(() => {
        switch (customer) {
            case "selfemployed":
                return "selvstændig";
            case "employee":
                return "ansat";
            case "unemployed":
                return "ledig";
            case "student":
                return "studerende";
            default:
                return "";
        }
    }, [customer]); 

    //Preselect products if they are set to "Default choosen" in Umbraco
    useEffect(() => {
        productList.map(product => {
            if(product.ProductTargetVariant === "akasse" && product.DefaultChoosen) {
                setUnemploymentBenefitsChecked(true);
            }
            if(product.ProductTargetVariant === "fagforening" && product.DefaultChoosen) {
                setUnionChecked(true);
            }
            if(product.ProductTargetVariant === "loensikring" && product.DefaultChoosen) {
                setSalaryInsuranceChecked(true);
            }
            if(product.ProductTargetVariant === "fagforeningloensikring" && product.DefaultChoosen) {
                setSalaryInsuranceUnionChecked(true);
            }
            if(product.ProductTargetVariant === "hrjura" && product.DefaultChoosen) {
                setHrJuraChecked(true);
            }
            if(product.ProductTargetVariant === "basis" && product.DefaultChoosen) {
                setBasisChecked(true);
            }
        })
        
    }, [productList])

    
    //Check if package layout is needed
    useEffect(() => {   
        if((unemploymentBenefitsChecked && unionChecked) || (unemploymentBenefitsChecked && salaryInsuranceUnionChecked)) {
            setIsPackage(true);
        } else {
            setIsPackage(false);
        }
    }, [unemploymentBenefitsChecked, unionChecked, salaryInsuranceUnionChecked, basisChecked])

    //Check if package layout for selfemployeed is needed
    useEffect(() => {   
        if(unemploymentBenefitsChecked && basisChecked) {
            setIsSelfemployeedPackage(true);
        } else {
            setIsSelfemployeedPackage(false);
        }
    }, [unemploymentBenefitsChecked, basisChecked])

    
    //Click on productcard
    const clickEvent = (productTargetVariant: string) => {
        if(productTargetVariant === "akasse") {
            unemploymentBenefitsChecked ? setUnemploymentBenefitsChecked(false) : setUnemploymentBenefitsChecked(true)
        } 
        if(productTargetVariant === "fagforening") {
            unionChecked ? setUnionChecked(false) : setUnionChecked(true)
        }
        if(productTargetVariant === "loensikring") {
            salaryInsuranceChecked ? setSalaryInsuranceChecked(false) : setSalaryInsuranceChecked(true)
        }
        if(productTargetVariant === "fagforeningloensikring") {
            //return
            salaryInsuranceUnionChecked ? setSalaryInsuranceUnionChecked(false) : setSalaryInsuranceUnionChecked(true)
        }
        if(productTargetVariant === "hrjura") {
            hrJuraChecked ? setHrJuraChecked(false) : setHrJuraChecked(true)
        }
        if(productTargetVariant === "basis") {
            basisChecked ? setBasisChecked(false) : setBasisChecked(true)
        }
        
    }

    const checkedInput = (productTargetVariant: string) => {
        if(productTargetVariant === "akasse") {
            return unemploymentBenefitsChecked
        } 
        if(productTargetVariant === "fagforening") {
            return unionChecked 
        }
        if(productTargetVariant === "loensikring") {
            return salaryInsuranceChecked
        }
        if(productTargetVariant === "fagforeningloensikring") {
            return salaryInsuranceUnionChecked
        }
        if(productTargetVariant === "hrjura") {
            return hrJuraChecked
        }
        if(productTargetVariant === "basis") {
            return basisChecked
        }
    }

    const clickBannerInfo = (productTargetVariant: string) => {
        if(productList.some(product => product.ProductTargetVariant === "fagforeningloensikring")) {
            if(productTargetVariant === "akasse") {
                setSalaryInsuranceUnionChecked(true)
            } else if (productTargetVariant ==="fagforeningloensikring") {
                setUnemploymentBenefitsChecked(true)
            }
        } else if(productList.some(product => product.ProductTargetVariant === "basis")){
            if(productTargetVariant === "akasse") {
                setBasisChecked(true)
            } else if (productTargetVariant ==="basis") {
                setUnemploymentBenefitsChecked(true)
            }
        } else {
            if(productTargetVariant === "akasse") {
                setUnionChecked(true);
            } else if(productTargetVariant === "fagforening") {
                setUnemploymentBenefitsChecked(true)
            } 
        }
    }

    const selfemployedPackageChecked = () => {
        if(productList.some(p => p.ProductTargetVariant === "basis") && productList.some(p => p.ProductTargetVariant === "akasse") && basisChecked && unemploymentBenefitsChecked) {
            return true
        } else {
            return false
        }
    }

    //Loop through products
    const ProductCardList = productList?.map(product => {
        const isSelfemployeedPackage = selfemployedPackageChecked() && (product.ProductTargetVariant === "basis" || product.ProductTargetVariant === "akasse");
        
        return (
        <ProductCard 
            id={product.ProductId} 
            data-attribute={checkedInput(product.ProductTargetVariant) && !isPackage ? dataAtrr : ``} 
            isPackage={isPackage} 
            key={product.ProductId} 
            checked={checkedInput(product.ProductTargetVariant)}
            isSelfemployeedPackage={isSelfemployeedPackage}
        >
            <TopContainerCard>
                <InputContainer productTargetVariant={product.ProductTargetVariant} onClick={() => clickEvent(product.ProductTargetVariant)}>
                    {/* {product.ProductTargetVariant !== "fagforeningloensikring" &&
                    <> */}
                        <Input  type="checkbox" id={`product`+`${product.ProductId}`} />
                        <CustomInput checked={checkedInput(product.ProductTargetVariant)}>
                        {checkedInput(product.ProductTargetVariant) && (
                            <Checked></Checked>
                        )}
                        </CustomInput>
                    {/* </>  
                    } */}
                    <Label htmlFor={`product`+`${product.ProductId}`}>{product.ProductTitle}</Label>
                    <ProductName productTargetVariant={product.ProductTargetVariant}>{product.ProductTitle}</ProductName>
                    {/* {product.ProductTargetVariant !== "fagforeningloensikring" && */}
                        <Price productTargetVariant={product.ProductTargetVariant} strikeThrough={isPackage && product.ProductTargetVariant === "fagforening"}>{(product.ProductTargetVariant === "hrjura" || product.ProductTargetVariant === "loensikring") && `Fra `} {unemploymentBenefitsChecked && basisChecked && product.ProductTargetVariant === "basis" ? `99` : product.Price} <span>kr./md.</span></Price>
                    {/* } */}
                </InputContainer>
                <UnorderedList>
                {(product.Features.length > 3 && openFeatureProductId !== product.ProductId) && (
                    product.Features.slice(0, 3).map(i =>
                        <InfoLi key={i.Key}>{i.FeatureTitle}</InfoLi>
                    )
                )}
                {(product.Features.length <= 3 || openFeatureProductId === product.ProductId) && (
                    product.Features.map(i =>
                        <InfoLi key={i.Key}>{i.FeatureTitle}</InfoLi>
                    )
                )}
                </UnorderedList>
                {(product.Features.length > 3) && (
                    <InfoBtn onClick={() => setOpenFeatureProductId(openFeatureProductId === product.ProductId ? null : product.ProductId)}>
                        {openFeatureProductId === product.ProductId ? "Se færre fordele" : "Se flere fordele"}
                    </InfoBtn>
                )}
            </TopContainerCard>
            {checkedInput(product.ProductTargetVariant) && !isPackage && !isSelfemployeedPackage && product.ProductBannerText &&
                <ProductInfo onClick={() => clickBannerInfo(product.ProductTargetVariant)} dangerouslySetInnerHTML={{__html: product.ProductBannerText || ""}} />
            }
        </ProductCard>
        );
    });
    
    //calculate totalPrice
    const totalPrice = useMemo(() => {
        let unemploymentBenefitsPrice = 0
        let unionPrice = 0 
        let salaryInsurancePrice = 0
        let salaryInsuranceAndUnionPrice = 0
        let hrJuraPrice = 0
        let basisPrice = 0 

        productList?.map(product => {
            if(product.ProductTargetVariant === "akasse") {
                unemploymentBenefitsPrice = unemploymentBenefitsChecked ? Number(product.Price) : 0 
            } 
            if(product.ProductTargetVariant === "fagforening") {
                unionPrice = unionChecked ? Number(product.Price) : 0
            }
            if(product.ProductTargetVariant === "loensikring") {
               salaryInsurancePrice = salaryInsuranceChecked ? Number(product.Price) : 0
            }
            if(product.ProductTargetVariant === "fagforeningloensikring") {
                salaryInsuranceAndUnionPrice = salaryInsuranceUnionChecked ? Number(product.Price) : 0
            }
            if(product.ProductTargetVariant === "hrjura") {
                hrJuraPrice = hrJuraChecked ? Number(product.Price) : 0
            }
            if(product.ProductTargetVariant === "basis") {
                if(unemploymentBenefitsChecked && basisChecked) {
                    basisPrice = 99
                } else {
                    basisPrice = basisChecked ? Number(product.Price) : 0
                }
            }
        })

        let fullPrice = 0

        if(isPackage && !productList.some(product => product.ProductTargetVariant === "fagforeningloensikring")) {
            fullPrice = unemploymentBenefitsPrice
        } else {
            fullPrice = unemploymentBenefitsPrice + unionPrice + salaryInsurancePrice + salaryInsuranceAndUnionPrice + hrJuraPrice + basisPrice
            setPackagePrice(fullPrice)
        }

        return fullPrice

    }, [productList, unemploymentBenefitsChecked, unionChecked, salaryInsuranceChecked, salaryInsuranceUnionChecked, hrJuraChecked, basisChecked, isPackage])

    //Choosen product added to url 
    const getChosenProductVariants = useMemo(() => {
        let chosen: string = "";
        productList.forEach(product => {
            if (
                (product.ProductTargetVariant === "akasse" && unemploymentBenefitsChecked) ||
                (product.ProductTargetVariant === "fagforening" && unionChecked) ||
                (product.ProductTargetVariant === "loensikring" && salaryInsuranceChecked) ||
                (product.ProductTargetVariant === "fagforeningloensikring" && salaryInsuranceUnionChecked) ||
                (product.ProductTargetVariant === "hrjura" && hrJuraChecked) ||
                (product.ProductTargetVariant === "basis" && basisChecked)
            ) {
                if(chosen.length > 0) {
                    chosen += `|${product.ProductTargetVariant}`;
                } else {
                    chosen += product.ProductTargetVariant;
                }
            }
        });
        setChosenProducts(chosen)
        return chosen;
    }, [unemploymentBenefitsChecked, unionChecked, salaryInsuranceChecked, salaryInsuranceUnionChecked, hrJuraChecked, basisChecked]);

    //Url with parameters
    const urlWithParameters = useMemo(() => {
        let url: string = `${btnUrl}?produkt=${getChosenProductVariants}`
        if(campaignSource != "" ) {
            url += `&campaign=${campaignSource}`
        }
        if(customer != "none") {
            url += `&type=${customer}`
        }
        if(productList.some(product => product.ProductTargetVariant === "basis" || product.ProductTargetVariant === "hrjura") || choosenStep2) {
            url += `&step=2`
        }
        return url
    }, [getChosenProductVariants]) 

    //Api send contact me
    const onSend = async () => {
        const chosenProductText = chosenProducts != "" ? `ring mig op om: ${chosenProducts}` : ", ingen produkter valgt"
        let lead = {} as BloomreachLeadModel;
        lead.firstName = firstName as string
        lead.phone = mobile as string
        lead.campaign = "Ring mig op"
        lead.source = `Produktkort ${campaignSource as string}`
        lead.occupation = customerTranslation as string
        lead.comment = `${chosenProductText}`

        await postBloomreachLead({
            ...lead
            }).then(() => {
            setShowContactMe(false);
            Analytics.getInstance().trackLeadFromProductCard(TrackingFlowTypeEnum.ProductCard)
            });
    } 

    //Validation for contact me inputs
    const checkSubmit = () => {
        if ((firstName && firstName.trim() !== "") && (mobile && mobile.trim() !== "") /* && (email && getEmailIsValid(email)) && consentChecked */) {
            onSend()
            setFirstName("");
            setMobile("");
            //setEmail("");
            //setConsentChecked(false);
            setShowMobileError(false)
            setShowFirstNameError(false)
            //setShowEmailError(false)
            //setShowConsentError(false)
        } else {
            if (!firstName || firstName.trim() === "") {
                setShowFirstNameError(true);
            }
            if (!mobile || mobile.trim() === "") {
                setShowMobileError(true);
            }
            /* if (!email || !getEmailIsValid(email)) {
                setShowEmailError(true);
            } */
           /*  if (!consentChecked) {
                setShowConsentError(true);
            } */
        }
    };

/*     const getEmailIsValid = (value: string) => {
        const normalizedEmail = value.trim();
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail);
    }; */

    //tracking
    const trackChosenProducts = useMemo(() => {
        let chosen: string = "";
        productList.forEach(product => {
            if (
                (product.ProductTargetVariant === "akasse" && unemploymentBenefitsChecked) ||
                (product.ProductTargetVariant === "fagforening" && unionChecked) ||
                (product.ProductTargetVariant === "loensikring" && salaryInsuranceChecked) ||
                (product.ProductTargetVariant === "fagforeningloensikring" && salaryInsuranceUnionChecked) ||
                (product.ProductTargetVariant === "hrjura" && hrJuraChecked) ||
                (product.ProductTargetVariant === "basis" && basisChecked)
            ) {
                if(chosen.length > 0) {
                    chosen += `, ${product.ProductTargetVariant}`;
                } else {
                    chosen += product.ProductTargetVariant;
                }
            }
        });
        setChosenProducts(chosen)
        return chosen;
    }, [unemploymentBenefitsChecked, unionChecked, salaryInsuranceChecked, salaryInsuranceUnionChecked, hrJuraChecked, basisChecked]);


    const tracking = () => {
        Analytics.getInstance().trackChosenProducts(trackChosenProducts)
    }


    // Helper to reset contact form fields
    const resetContactFields = () => {
        setFirstName("");
        setMobile("");
        //setEmail("");
        setShowFirstNameError(false);
        setShowMobileError(false);
        //setShowEmailError(false);
    };

    return (
        <>
        <Background>
            <Container>
                {headline != "" && headline != undefined &&
                    <Headline>{headline}</Headline>
                }
                {subtitle != "" && subtitle != undefined &&
                    <Subtitle dangerouslySetInnerHTML={{__html: subtitle || ""}} />
                }
                <PackageContainer data-attribute={isPackage ? dataAtrr : ``} isPackage={isPackage}>
                    <ProductCardContainer>
                        {ProductCardList}
                    </ProductCardContainer>
                    {isPackage && packageText &&
                        <PackageInfo dangerouslySetInnerHTML={{__html: packageText || ""}}/>
                    }
                    <TotalTop isPackage={isPackage} data-attribute="total-top">
                        <TotalRow>
                            <TotalText>
                                Pris {(hrJuraChecked || salaryInsuranceChecked) && `fra`}
                                {isPackage && !productList.some(product => product.ProductTargetVariant === "fagforeningloensikring") &&
                                <span> i <b>{discountToken} mdr.</b></span>
                                }
                            </TotalText>
                            <TotalPrice>{totalPrice} <span>kr./md.</span></TotalPrice>
                        </TotalRow>
                         {isPackage && !productList.some(product => product.ProductTargetVariant === "fagforeningloensikring") &&
                         <TotalRow style={{marginTop: "10px", fontSize: "16px", borderTop: "1px solid #ffffff3b", paddingTop: "4px"}}>
                            <TotalText>Efter {discountToken} mdr.</TotalText>
                            <TotalPrice><span>{packagePrice} kr./md.</span></TotalPrice>
                         </TotalRow>   
                        }
                    </TotalTop>
                </PackageContainer>
                <TotalBottom data-attribute="total-bottom">
                    <TotalCall>
                        <a onClick={() => setShowContactMe(true)}>{callText}</a>
                    </TotalCall>
                </TotalBottom>
                <ButtonContainer>
                    <Button className="button" onClick={tracking} active={chosenProducts?.length !== 0} href={urlWithParameters}>{btnText}</Button>
                </ButtonContainer>
            </Container>
        </Background>
        {showContactMe &&
            <ContactMeContainer data-attribute="contact-me">
                <Close>
                    <CloseIcon onClick={() => { setShowContactMe(false); resetContactFields(); }} />
                </Close>
                <ContactMeContent>
                    <ContactMeHeadline>Vi er her for at hjælpe dig</ContactMeHeadline>
                    <ContactMeSubtitle>Snak med en rådgiver og få den løsning, der passer til dig. Udfyld formularen og vi ringer til dig.</ContactMeSubtitle>
                    <ModalInputContainer>
                        <ModalInput id="name" type="text" placeholder="Dit navn" autoComplete="given-name"  
                            onChange={(e) => {
                                setFirstName(e.currentTarget.value);
                            }}
                        />
                        {showFirstNameError && (firstName === undefined || firstName === "") &&
                            <ErrorMessage>Hov, her skal dit navn stå</ErrorMessage>
                        }
                        <ModalInput id="tel" type="tel" placeholder="Dit telefonnummer" autoComplete="tel"
                            onChange={(e) => {
                                setMobile(e.currentTarget.value);
                            }}
                        />
                        {showMobileError && (mobile === undefined  || mobile === "") && 
                            <ErrorMessage>Hov, vi kan ikke ringe til dig uden telefonnummer</ErrorMessage>
                        }

                        {/* 
                        Email removed 22/06/2026
                        <ModalInput
                            id="email"
                            type="email"
                            placeholder="Din email"
                            autoComplete="email"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.currentTarget.value);
                                if (showEmailError) {
                                    setShowEmailError(!getEmailIsValid(e.currentTarget.value));
                                }
                            }}
                        />
                        {showEmailError && <ErrorMessage>Hov, indtast en gyldig email</ErrorMessage>} */}
                    </ModalInputContainer>
                  {/*   
                  Consent removed 22/06/2026
                  <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "24px", marginTop: "8px" }}>
                        <input
                            type="checkbox"
                            id="acceptContact"
                            checked={consentChecked}
                            onChange={e => {
                                setConsentChecked(e.target.checked);
                                if (showConsentError) setShowConsentError(!e.target.checked);
                            }}
                            className="customCheckbox"
                        />
                        <span className="checkmark"></span>
                        <label htmlFor="acceptContact" style={{ fontSize: "12px", color: "#FFF", cursor: "pointer", width: "90%" }}>
                            Ja tak – jeg vil gerne modtage eksklusive rabatter og medlemstilbud fra Ases <a target="_blank" href="https://www.ase.dk/gdpr/ase-a-kasse-samarbejdspartnere" style={{ textDecoration: "underline" }}>fordelspartnere</a> samt udvalgte medlemsfordele fra Ase, som kan spare mig penge i hverdagen. <br/>Det er altid Ase, der kontakter mig.<br/>Jeg må kontaktes via e‑mail, sms og telefon. Mit samtykke kan altid trækkes tilbage.
                        </label>
                    </div>
                    {showConsentError && <ErrorMessage>Hov, du skal give samtykke for at fortsætte</ErrorMessage>}*/}
                    <Button className="button" onClick={checkSubmit} active={true}>Ring mig op</Button>
                </ContactMeContent>
            </ContactMeContainer>
        }
    </>
    )

}